// 这个是写在 wuji xy-client 里面的逻辑
// 那里会把信息放到 window 全局变量里
// 比较脏，以后看看要不要调整下
/**
 * 判断当前是否是移动端
 *
 * 是Vue2响应时的，可以在 Vue computed 和 watch 里使用
 *
 * 耦合自 无极2.0 xy-client 的逻辑
 */
export const isMobile = () => {
  if (!window.xyScreenInfo) return false;
  return !!window.xyScreenInfo.isMobile;
};